export const dummyData = {
  fgi: {
    details: [
      {
        active_harvests: [
          {
            id: 125,
            metrc_harvest_id: 2222002,
            harvest_name: 'Lemon Cherry Gelato H12',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Lemon Cherry Gelato',
                total_package_weight: 16.678,
                plant_count: 53,
                flower_price: null,
                original_weight: 16.678,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 36.77,
                strain_total_price: 0,
                min_package_date: '2025-01-03',
                total_active_quantity: 25.14,
                percent_on_hand: 68.371,
                days_in_inventory: 361,
              },
            ],
          },
          {
            id: 126,
            metrc_harvest_id: 2222007,
            harvest_name: 'Divine Mintz H12',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Divine Mintz',
                total_package_weight: 6.222,
                plant_count: 100,
                flower_price: 800,
                original_weight: 6.222,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 13.72,
                strain_total_price: 10976,
                min_package_date: '2025-01-03',
                total_active_quantity: 0.84,
                percent_on_hand: 6.1224,
                days_in_inventory: 361,
              },
            ],
          },
          {
            id: 127,
            metrc_harvest_id: 2222103,
            harvest_name: 'Red Cab H12',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Red Cab',
                total_package_weight: 4.863,
                plant_count: 106,
                flower_price: 800,
                original_weight: 4.863,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 10.72,
                strain_total_price: 8576,
                min_package_date: '2025-01-03',
                total_active_quantity: 0.44,
                percent_on_hand: 4.1045,
                days_in_inventory: 361,
              },
            ],
          },
          {
            id: 128,
            metrc_harvest_id: 2222402,
            harvest_name: 'Killer Bee H12',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Killer B',
                total_package_weight: 14.552,
                plant_count: 207,
                flower_price: 800,
                original_weight: 14.552,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 32.08,
                strain_total_price: 25664,
                min_package_date: '2025-01-03',
                total_active_quantity: 8.29,
                percent_on_hand: 25.8416,
                days_in_inventory: 361,
              },
            ],
          },
          {
            id: 129,
            metrc_harvest_id: 2345506,
            harvest_name: 'H13 Killer Bee',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Killer B',
                total_package_weight: 15.91465,
                plant_count: 361,
                flower_price: 800,
                original_weight: 15.91465,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 35.09,
                strain_total_price: 28072,
                min_package_date: '2025-08-05',
                total_active_quantity: 6.52,
                percent_on_hand: 18.5808,
                days_in_inventory: 147,
              },
            ],
          },
          {
            id: 130,
            metrc_harvest_id: 2345517,
            harvest_name: 'H13 Carbon Fiber',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Carbon Fiber',
                total_package_weight: 10.653235,
                plant_count: 172,
                flower_price: 800,
                original_weight: 10.653235,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 23.49,
                strain_total_price: 18792,
                min_package_date: '2025-02-14',
                total_active_quantity: 13.45,
                percent_on_hand: 57.2584,
                days_in_inventory: 319,
              },
            ],
          },
          {
            id: 131,
            metrc_harvest_id: 2411614,
            harvest_name: 'Red Cab H16',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Red Cab',
                total_package_weight: 7.1,
                plant_count: 73,
                flower_price: 800,
                original_weight: 7.1,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 15.65,
                strain_total_price: 12520,
                min_package_date: '2025-05-23',
                total_active_quantity: 0.06,
                percent_on_hand: 0.3834,
                days_in_inventory: 221,
              },
            ],
          },
          {
            id: 132,
            metrc_harvest_id: 2411615,
            harvest_name: 'Killer Bee H16',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Killer B',
                total_package_weight: 14.37,
                plant_count: 179,
                flower_price: 800,
                original_weight: 14.37,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 31.68,
                strain_total_price: 25344,
                min_package_date: '2025-03-25',
                total_active_quantity: 11.12,
                percent_on_hand: 35.101,
                days_in_inventory: 280,
              },
            ],
          },
          {
            id: 133,
            metrc_harvest_id: 2411616,
            harvest_name: 'Carbon Fiber H16',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Carbon Fiber',
                total_package_weight: 10,
                plant_count: 132,
                flower_price: 800,
                original_weight: 10,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 22.05,
                strain_total_price: 17640,
                min_package_date: '2025-03-25',
                total_active_quantity: 18.27,
                percent_on_hand: 82.8571,
                days_in_inventory: 280,
              },
            ],
          },
          {
            id: 134,
            metrc_harvest_id: 2411816,
            harvest_name: 'Divine Mintz H16',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Divine Mintz',
                total_package_weight: 9.888,
                plant_count: 180,
                flower_price: 800,
                original_weight: 9.888,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 21.8,
                strain_total_price: 17440,
                min_package_date: '2025-03-21',
                total_active_quantity: 13.51,
                percent_on_hand: 61.9725,
                days_in_inventory: 284,
              },
            ],
          },
          {
            id: 135,
            metrc_harvest_id: 2464002,
            harvest_name: '2025-05-09-Dry Room-H',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Killer B',
                total_package_weight: 27.24,
                plant_count: 591,
                flower_price: 800,
                original_weight: 27.24,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 60.05,
                strain_total_price: 48040,
                min_package_date: null,
                total_active_quantity: 0,
                percent_on_hand: 0,
                days_in_inventory: 0,
              },
            ],
          },
          {
            id: 136,
            metrc_harvest_id: 2507221,
            harvest_name: 'Garlic0626',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Garlic Juice',
                total_package_weight: 3.834,
                plant_count: 215,
                flower_price: 800,
                original_weight: 3.834,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 8.45,
                strain_total_price: 6760,
                min_package_date: '2025-07-10',
                total_active_quantity: 4.95,
                percent_on_hand: 58.5799,
                days_in_inventory: 173,
              },
            ],
          },
          {
            id: 137,
            metrc_harvest_id: 2507222,
            harvest_name: 'Red0626',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Red Cab',
                total_package_weight: 5.3395,
                plant_count: 115,
                flower_price: 800,
                original_weight: 5.3395,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 11.77,
                strain_total_price: 9416,
                min_package_date: '2025-07-10',
                total_active_quantity: 7.48,
                percent_on_hand: 63.5514,
                days_in_inventory: 173,
              },
            ],
          },
          {
            id: 138,
            metrc_harvest_id: 2507223,
            harvest_name: 'Divine0626',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Divine Mintz',
                total_package_weight: 1.509,
                plant_count: 83,
                flower_price: 800,
                original_weight: 1.509,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 3.33,
                strain_total_price: 2664,
                min_package_date: '2025-07-10',
                total_active_quantity: 1.65,
                percent_on_hand: 49.5495,
                days_in_inventory: 173,
              },
            ],
          },
          {
            id: 139,
            metrc_harvest_id: 2507302,
            harvest_name: 'KB0626',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Killer B',
                total_package_weight: 6.802,
                plant_count: 120,
                flower_price: 800,
                original_weight: 6.802,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 15,
                strain_total_price: 12000,
                min_package_date: '2025-07-10',
                total_active_quantity: 6.6,
                percent_on_hand: 44,
                days_in_inventory: 173,
              },
            ],
          },
          {
            id: 140,
            metrc_harvest_id: 2556327,
            harvest_name: 'harvest 18',
            current_status: 'harvests_active',
            strains: [
              {
                strain_name: 'Carbon Fiber',
                total_package_weight: 2.1662,
                plant_count: 87,
                flower_price: 800,
                original_weight: 2.1662,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 4.776,
                strain_total_price: 19104,
                min_package_date: '2025-09-03',
                total_active_quantity: 4.762,
                percent_on_hand: 99.7069,
                days_in_inventory: 118,
              },
              {
                strain_name: 'Divine Mintz',
                total_package_weight: 2.1662,
                plant_count: 87,
                flower_price: 800,
                original_weight: 2.1662,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 4.776,
                strain_total_price: 19104,
                min_package_date: '2025-09-03',
                total_active_quantity: 4.762,
                percent_on_hand: 99.7069,
                days_in_inventory: 118,
              },
              {
                strain_name: 'Garlic Juice',
                total_package_weight: 2.1662,
                plant_count: 87,
                flower_price: 800,
                original_weight: 2.1662,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 4.776,
                strain_total_price: 19104,
                min_package_date: '2025-09-03',
                total_active_quantity: 4.762,
                percent_on_hand: 99.7069,
                days_in_inventory: 118,
              },
              {
                strain_name: 'Killer B',
                total_package_weight: 2.1662,
                plant_count: 87,
                flower_price: 800,
                original_weight: 2.1662,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 4.776,
                strain_total_price: 19104,
                min_package_date: '2025-09-03',
                total_active_quantity: 4.762,
                percent_on_hand: 99.7069,
                days_in_inventory: 118,
              },
              {
                strain_name: 'Kush Mintz',
                total_package_weight: 2.1662,
                plant_count: 87,
                flower_price: null,
                original_weight: 2.1662,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 4.776,
                strain_total_price: 0,
                min_package_date: '2025-09-03',
                total_active_quantity: 4.762,
                percent_on_hand: 99.7069,
                days_in_inventory: 118,
              },
            ],
          },
        ],
        inactive_harvests: [
          {
            id: 113,
            metrc_harvest_id: 1403001,
            harvest_name: 'H1: Carbon Fiber: 11/18/2023',
            current_status: 'harvests_inactive',
            strains: [
              {
                strain_name: 'Carbon Fiber',
                total_package_weight: 4.67,
                plant_count: 63,
                flower_price: 800,
                original_weight: 4.67,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 10.3,
                strain_total_price: 8240,
                min_package_date: '2023-12-10',
                total_active_quantity: 0.02,
                percent_on_hand: 0.1942,
                days_in_inventory: 751,
              },
            ],
          },
          {
            id: 114,
            metrc_harvest_id: 1403002,
            harvest_name: 'H1: Divine Mints: 11/18/2023',
            current_status: 'harvests_inactive',
            strains: [
              {
                strain_name: 'Divine Mintz',
                total_package_weight: 2.927,
                plant_count: 33,
                flower_price: 800,
                original_weight: 2.927,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 6.45,
                strain_total_price: 5160,
                min_package_date: '2024-01-09',
                total_active_quantity: 0,
                percent_on_hand: 0,
                days_in_inventory: 721,
              },
            ],
          },
          {
            id: 115,
            metrc_harvest_id: 1403003,
            harvest_name: 'H1: Dosilato: 11/18/2023',
            current_status: 'harvests_inactive',
            strains: [
              {
                strain_name: 'Dosilato',
                total_package_weight: 1.34,
                plant_count: 15,
                flower_price: null,
                original_weight: 1.34,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 2.95,
                strain_total_price: 0,
                min_package_date: '2024-01-29',
                total_active_quantity: 0,
                percent_on_hand: 0,
                days_in_inventory: 701,
              },
            ],
          },
          {
            id: 116,
            metrc_harvest_id: 1403004,
            harvest_name: 'H1: Fireball: 11/18/2023',
            current_status: 'harvests_inactive',
            strains: [
              {
                strain_name: 'Fireball',
                total_package_weight: 2.843,
                plant_count: 30,
                flower_price: null,
                original_weight: 2.843,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 6.27,
                strain_total_price: 0,
                min_package_date: null,
                total_active_quantity: 0,
                percent_on_hand: 0,
                days_in_inventory: 0,
              },
            ],
          },
          {
            id: 117,
            metrc_harvest_id: 1403005,
            harvest_name: 'H1: Galactic Runtz: 11/18/2023',
            current_status: 'harvests_inactive',
            strains: [
              {
                strain_name: 'Galactic Runtz',
                total_package_weight: 0.862,
                plant_count: 12,
                flower_price: null,
                original_weight: 0.862,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 1.9,
                strain_total_price: 0,
                min_package_date: '2024-01-29',
                total_active_quantity: 0,
                percent_on_hand: 0,
                days_in_inventory: 701,
              },
            ],
          },
          {
            id: 118,
            metrc_harvest_id: 1403006,
            harvest_name: 'H1: Hippy Crasher: 11/18/2023',
            current_status: 'harvests_inactive',
            strains: [
              {
                strain_name: 'Hippy Crasher',
                total_package_weight: 2.396,
                plant_count: 33,
                flower_price: null,
                original_weight: 2.396,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 5.28,
                strain_total_price: 0,
                min_package_date: '2024-01-09',
                total_active_quantity: 0,
                percent_on_hand: 0,
                days_in_inventory: 721,
              },
            ],
          },
          {
            id: 119,
            metrc_harvest_id: 1403007,
            harvest_name: 'H1: Jelly Breath: 11/18/2023',
            current_status: 'harvests_inactive',
            strains: [
              {
                strain_name: 'Jelly Breath',
                total_package_weight: 1.226,
                plant_count: 12,
                flower_price: null,
                original_weight: 1.226,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 2.7,
                strain_total_price: 0,
                min_package_date: null,
                total_active_quantity: 0,
                percent_on_hand: 0,
                days_in_inventory: 0,
              },
            ],
          },
          {
            id: 120,
            metrc_harvest_id: 1403008,
            harvest_name: 'H1: Killer B: 11/18/2023',
            current_status: 'harvests_inactive',
            strains: [
              {
                strain_name: 'Killer B',
                total_package_weight: 4.669,
                plant_count: 48,
                flower_price: 800,
                original_weight: 4.669,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 10.29,
                strain_total_price: 8232,
                min_package_date: '2024-01-09',
                total_active_quantity: 0,
                percent_on_hand: 0,
                days_in_inventory: 721,
              },
            ],
          },
          {
            id: 121,
            metrc_harvest_id: 1403009,
            harvest_name: 'H1: Oreo Mints: 11/18/2023',
            current_status: 'harvests_inactive',
            strains: [
              {
                strain_name: 'Oreo Mintz',
                total_package_weight: 3.351,
                plant_count: 48,
                flower_price: null,
                original_weight: 3.351,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 7.39,
                strain_total_price: 0,
                min_package_date: '2024-01-09',
                total_active_quantity: 0,
                percent_on_hand: 0,
                days_in_inventory: 721,
              },
            ],
          },
          {
            id: 122,
            metrc_harvest_id: 1403010,
            harvest_name: 'H1: Sherb Mac: 11/18/2023',
            current_status: 'harvests_inactive',
            strains: [
              {
                strain_name: 'Sherb Mac',
                total_package_weight: 1.364,
                plant_count: 24,
                flower_price: null,
                original_weight: 1.364,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 3.01,
                strain_total_price: 0,
                min_package_date: '2024-01-09',
                total_active_quantity: 0,
                percent_on_hand: 0,
                days_in_inventory: 721,
              },
            ],
          },
          {
            id: 123,
            metrc_harvest_id: 1403011,
            harvest_name: 'H1: Southern Sugar: 11/18/2023',
            current_status: 'harvests_inactive',
            strains: [
              {
                strain_name: 'Southern Sugar',
                total_package_weight: 3.356,
                plant_count: 45,
                flower_price: null,
                original_weight: 3.356,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 7.4,
                strain_total_price: 0,
                min_package_date: '2024-01-09',
                total_active_quantity: 0,
                percent_on_hand: 0,
                days_in_inventory: 721,
              },
            ],
          },
          {
            id: 124,
            metrc_harvest_id: 1403012,
            harvest_name: 'H1: Super Bad: 11/18/2023',
            current_status: 'harvests_inactive',
            strains: [
              {
                strain_name: 'Super Bad',
                total_package_weight: 4.424,
                plant_count: 42,
                flower_price: null,
                original_weight: 4.424,
                original_unit: 'Kilograms',
                converted_package_weight_lbs: 9.75,
                strain_total_price: 0,
                min_package_date: '2024-01-09',
                total_active_quantity: 0,
                percent_on_hand: 0,
                days_in_inventory: 721,
              },
            ],
          },
        ],
        active_count: 16,
        inactive_count: 12,
        total_inactive_plant_count: 405,
        total_package_weight_kg: 199.22438499999993,
        total_package_weight_lbs: 439.22,
        total_strain_price: 341952,
        total_available_quantity_all: 142.15000000000003,
        on_hand_percent: 32.36,
        avg_price_per_lbs: 2405.57,
      },
    ],
    start_of_year: '2023-01-01',
  },
  projections: [
    {
      title: 'Plant count',
      description: '',
      value: 3,
      icon: '',
      id: 0,
    },
    {
      title: 'Revenue',
      description: '',
      value: 2.88,
      icon: '',
      id: 1,
    },
  ],
  farms: [
    {
      id: 1,
      farm_name: 'JRAY Farms LLC',
      license_number: 'GAAA-WFMU-PPC5',
    },
  ],
  farm_performance: {
    total_plant_count: 405,
    total_current_weight_lbs: 308.06,
    total_wet_weight_lbs: 400.82,
    total_package_weight_lbs: 73.7,
    total_waste_weight_lbs: 19.07,
    total_yield_percent: 18.39,
    light: 100,
    details: [
      {
        id: 113,
        metrc_harvest_id: 1403001,
        harvest_name: 'H1: Carbon Fiber: 11/18/2023',
        current_status: 'harvests_inactive',
        strains: [
          {
            source_strain_name: 'Carbon Fiber',
            total_package_weight: 4.67,
            total_package_weight_lbs: 10.3,
            current_weight: 18.774,
            current_weight_lbs: 41.39,
            plant_count: 63,
            total_waste_weight: 1.316,
            total_waste_weight_lbs: 2.9,
            total_wet_weight: 24.76,
            total_wet_weight_lbs: 54.59,
            unit_of_weight_name: 'Kilograms',
          },
        ],
      },
      {
        id: 114,
        metrc_harvest_id: 1403002,
        harvest_name: 'H1: Divine Mints: 11/18/2023',
        current_status: 'harvests_inactive',
        strains: [
          {
            source_strain_name: 'Divine Mintz',
            total_package_weight: 2.927,
            total_package_weight_lbs: 6.45,
            current_weight: 14.298,
            current_weight_lbs: 31.52,
            plant_count: 33,
            total_waste_weight: 0.65,
            total_waste_weight_lbs: 1.43,
            total_wet_weight: 17.875,
            total_wet_weight_lbs: 39.41,
            unit_of_weight_name: 'Kilograms',
          },
        ],
      },
      {
        id: 115,
        metrc_harvest_id: 1403003,
        harvest_name: 'H1: Dosilato: 11/18/2023',
        current_status: 'harvests_inactive',
        strains: [
          {
            source_strain_name: 'Dosilato',
            total_package_weight: 1.34,
            total_package_weight_lbs: 2.95,
            current_weight: 5.034,
            current_weight_lbs: 11.1,
            plant_count: 15,
            total_waste_weight: 0.346,
            total_waste_weight_lbs: 0.76,
            total_wet_weight: 6.72,
            total_wet_weight_lbs: 14.82,
            unit_of_weight_name: 'Kilograms',
          },
        ],
      },
      {
        id: 116,
        metrc_harvest_id: 1403004,
        harvest_name: 'H1: Fireball: 11/18/2023',
        current_status: 'harvests_inactive',
        strains: [
          {
            source_strain_name: 'Fireball',
            total_package_weight: 2.843,
            total_package_weight_lbs: 6.27,
            current_weight: 11.157,
            current_weight_lbs: 24.6,
            plant_count: 30,
            total_waste_weight: 0.845,
            total_waste_weight_lbs: 1.86,
            total_wet_weight: 14.845,
            total_wet_weight_lbs: 32.73,
            unit_of_weight_name: 'Kilograms',
          },
        ],
      },
      {
        id: 117,
        metrc_harvest_id: 1403005,
        harvest_name: 'H1: Galactic Runtz: 11/18/2023',
        current_status: 'harvests_inactive',
        strains: [
          {
            source_strain_name: 'Galactic Runtz',
            total_package_weight: 0.862,
            total_package_weight_lbs: 1.9,
            current_weight: 3.538,
            current_weight_lbs: 7.8,
            plant_count: 12,
            total_waste_weight: 0.245,
            total_waste_weight_lbs: 0.54,
            total_wet_weight: 4.645,
            total_wet_weight_lbs: 10.24,
            unit_of_weight_name: 'Kilograms',
          },
        ],
      },
      {
        id: 118,
        metrc_harvest_id: 1403006,
        harvest_name: 'H1: Hippy Crasher: 11/18/2023',
        current_status: 'harvests_inactive',
        strains: [
          {
            source_strain_name: 'Hippy Crasher',
            total_package_weight: 2.396,
            total_package_weight_lbs: 5.28,
            current_weight: 10.058,
            current_weight_lbs: 22.17,
            plant_count: 33,
            total_waste_weight: 0.761,
            total_waste_weight_lbs: 1.68,
            total_wet_weight: 13.215,
            total_wet_weight_lbs: 29.13,
            unit_of_weight_name: 'Kilograms',
          },
        ],
      },
      {
        id: 119,
        metrc_harvest_id: 1403007,
        harvest_name: 'H1: Jelly Breath: 11/18/2023',
        current_status: 'harvests_inactive',
        strains: [
          {
            source_strain_name: 'Jelly Breath',
            total_package_weight: 1.226,
            total_package_weight_lbs: 2.7,
            current_weight: 5.032,
            current_weight_lbs: 11.09,
            plant_count: 12,
            total_waste_weight: 0.282,
            total_waste_weight_lbs: 0.62,
            total_wet_weight: 6.54,
            total_wet_weight_lbs: 14.42,
            unit_of_weight_name: 'Kilograms',
          },
        ],
      },
      {
        id: 120,
        metrc_harvest_id: 1403008,
        harvest_name: 'H1: Killer B: 11/18/2023',
        current_status: 'harvests_inactive',
        strains: [
          {
            source_strain_name: 'Killer B',
            total_package_weight: 4.669,
            total_package_weight_lbs: 10.29,
            current_weight: 19.555,
            current_weight_lbs: 43.11,
            plant_count: 48,
            total_waste_weight: 1.022,
            total_waste_weight_lbs: 2.25,
            total_wet_weight: 25.246,
            total_wet_weight_lbs: 55.66,
            unit_of_weight_name: 'Kilograms',
          },
        ],
      },
      {
        id: 121,
        metrc_harvest_id: 1403009,
        harvest_name: 'H1: Oreo Mints: 11/18/2023',
        current_status: 'harvests_inactive',
        strains: [
          {
            source_strain_name: 'Oreo Mintz',
            total_package_weight: 3.351,
            total_package_weight_lbs: 7.39,
            current_weight: 14.331,
            current_weight_lbs: 31.59,
            plant_count: 48,
            total_waste_weight: 1.233,
            total_waste_weight_lbs: 2.72,
            total_wet_weight: 18.915,
            total_wet_weight_lbs: 41.7,
            unit_of_weight_name: 'Kilograms',
          },
        ],
      },
      {
        id: 122,
        metrc_harvest_id: 1403010,
        harvest_name: 'H1: Sherb Mac: 11/18/2023',
        current_status: 'harvests_inactive',
        strains: [
          {
            source_strain_name: 'Sherb Mac',
            total_package_weight: 1.364,
            total_package_weight_lbs: 3.01,
            current_weight: 7.766,
            current_weight_lbs: 17.12,
            plant_count: 24,
            total_waste_weight: 0.34,
            total_waste_weight_lbs: 0.75,
            total_wet_weight: 9.47,
            total_wet_weight_lbs: 20.88,
            unit_of_weight_name: 'Kilograms',
          },
        ],
      },
      {
        id: 123,
        metrc_harvest_id: 1403011,
        harvest_name: 'H1: Southern Sugar: 11/18/2023',
        current_status: 'harvests_inactive',
        strains: [
          {
            source_strain_name: 'Southern Sugar',
            total_package_weight: 3.356,
            total_package_weight_lbs: 7.4,
            current_weight: 14.204,
            current_weight_lbs: 31.31,
            plant_count: 45,
            total_waste_weight: 0.53,
            total_waste_weight_lbs: 1.17,
            total_wet_weight: 18.09,
            total_wet_weight_lbs: 39.88,
            unit_of_weight_name: 'Kilograms',
          },
        ],
      },
      {
        id: 124,
        metrc_harvest_id: 1403012,
        harvest_name: 'H1: Super Bad: 11/18/2023',
        current_status: 'harvests_inactive',
        strains: [
          {
            source_strain_name: 'Super Bad',
            total_package_weight: 4.424,
            total_package_weight_lbs: 9.75,
            current_weight: 15.986,
            current_weight_lbs: 35.24,
            plant_count: 42,
            total_waste_weight: 1.08,
            total_waste_weight_lbs: 2.38,
            total_wet_weight: 21.49,
            total_wet_weight_lbs: 47.38,
            unit_of_weight_name: 'Kilograms',
          },
        ],
      },
    ],
  },
};
